module.exports = __webpack_public_path__ + "img/js.1b9e61fb.png";